import { type ParsedClaims, PaymentType } from '../context/claims';
import { type DeviceAdapter } from '../../platform/device/DeviceAdapter';

function isQrEligiblePaymentType(paymentType: PaymentType): boolean {
  return (
    [PaymentType.EXPRESS, PaymentType.PAYMENT, PaymentType.PSP_PAYMENT] as PaymentType[]
  ).includes(paymentType);
}

function isQrForcedByQueryParam(): boolean {
  return new URLSearchParams(window.location.search).get('forceQr') === 'true';
}

function isQrCapableDevice(device: DeviceAdapter): boolean {
  if (device.isMobile) return false;

  if (device.isWebView) return false;

  return true;
}

export function shouldShowQrCode(claims: ParsedClaims | null, device: DeviceAdapter): boolean {
  // NO QR for RECURRING
  if (!claims || !isQrEligiblePaymentType(claims.paymentType)) {
    return false;
  }

  // CANNOT TYPE IN NUMBER ON DESKTOP = SHOW QR
  if (claims.blockPhoneNumberInput) {
    return isQrCapableDevice(device);
  }

  // forces QR -> show QR
  if (isQrForcedByQueryParam()) {
    return true;
  }

  return false;
}
